/**
 * "Your referral rewards" (docs/Decisions.md D68 item 4, D73): won deals
 * that came through the member's recommendations, what each earned (money,
 * credits or attribution) and whether it has been paid. Money is paid
 * through Stripe Connect after the vendor's invoice is paid (CR-39).
 */
import { useEffect, useState } from 'react';
import * as marketApi from '../api/marketplace';
import PayoutAccountCard from './PayoutAccountCard';
import { formatDate } from './ui';
import { PAYOUT_STATE_LABELS, formatUsd } from '../lib/marketplace';
import { cn, ui } from '../lib/ui';

function earned(r) {
  if (r.cents > 0) return formatUsd(r.cents);
  if (r.type === 'credits') return r.credits;
  if (r.blocked === 'licensed') return 'Credited (money rewards are off in licensed categories)';
  if (r.blocked === 'investment') return 'Credited';
  return 'Credited';
}

export default function MyRewards() {
  const [data, setData] = useState(null);

  useEffect(() => {
    marketApi
      .listMyRewards()
      .then(setData)
      .catch(() => setData({ rewards: [], totals: { earnedCents: 0, paidCents: 0 } }));
  }, []);

  if (!data || data.rewards.length === 0) return null;
  const money = data.rewards.some(r => r.cents > 0);
  return (
    <section aria-labelledby="rewards-heading" className="mt-8">
      <h2 id="rewards-heading" className={ui.h2}>
        Your referral rewards
      </h2>
      <p className={cn(ui.hint, 'mt-0')}>
        Earned {formatUsd(data.totals.earnedCents)}, paid out {formatUsd(data.totals.paidCents)}.
      </p>
      <ul className="m-0 mb-4 list-none p-0">
        {data.rewards.map(r => (
          <li key={r.entryId} className={cn(ui.row, ui.spread, 'border-b border-z-line py-2')}>
            <span>
              <strong>{r.vendorName}</strong> - {r.serviceName}
              <span className={cn(ui.hint, 'block')}>Won {formatDate(r.wonAt)}</span>
            </span>
            <span className="text-right">
              {earned(r)}
              {r.cents > 0 && (
                <span className={cn(ui.hint, 'block')}>{PAYOUT_STATE_LABELS[r.state]}</span>
              )}
            </span>
          </li>
        ))}
      </ul>
      {money && <PayoutAccountCard kind="user" title="Get your rewards paid" />}
    </section>
  );
}
